import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    attributeToEditOrder: null,
    attributesList: [],
    attributesSetList: [],
    attributeSetToEdit: {},
    attributesListIsDrawed: true
  },

  mutations: {
    UPDATE_ATT_LIST (state, attList) {
      state.attributesList = attList
    },
    UPDATE_ATT_SET_LIST (state, attSetList) {
      state.attributesSetList = attSetList
    },
    SET_ATT_TO_EDIT (state, attId) {
      state.attributeToEditOrder = attId
    },
    SET_ATTSET_TO_EDIT (state, attSet) {
      state.attributeSetToEdit = attSet
    },
    EDIT_ATTRIBUTE_ON_LIST (state, att) {
      state.attributesList[att.order - 1] = att
    },
    ADD_ATTRIBUTE_TO_LIST (state, att) {
      att.order = state.attributesList.length + 1
      state.attributesList.push(att)
    },
    REMOVE_ATTRIBUTE_FROM_LIST (state, attOrder) {
      state.attributesList.splice(attOrder - 1, 1)
    },
    CLEAR_ATTRIBUTE_SET_TO_EDIT (state) {
      state.attributeSetToEdit = null
      state.attributesSetList = []
    },
    CLEAR_EDIT_ATTRIBUTE_ID_TO_EDIT (state) {
      state.attributeToEditOrder = null
    },
    CLEAR_ATTRIBUTE_LIST (state) {
      state.attributesList = []
    },
    REDRAW_LIST_OF_ATTRIBUTES (state) {
      state.attributesListIsDrawed = false
      state.attributesListIsDrawed = true
    },
    CLEAR_EDIT_ATTRIBUTE (state) {
      state.attributesList = {}
    }
  },

  actions: {
    updateAttList: ({ commit }, attList) => {
      commit('UPDATE_ATT_LIST', attList)
      commit('REDRAW_LIST_OF_ATTRIBUTES')
    },

    getAttributesSet: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/attributesSet/')
          .then(response => resolve(response.data))
          .catch(error => reject(error.data))
      })
    },

    setAttributesSetList: ({ commit }, attSetList) => {
      commit('UPDATE_ATT_SET_LIST', attSetList)
    },

    setAttributeToEdit: ({ commit }, attId) => {
      commit('SET_ATT_TO_EDIT', attId)
    },

    setAttributesSetToEdit: ({ commit }, attSet) => {
      commit('SET_ATTSET_TO_EDIT', attSet)
      commit('UPDATE_ATT_LIST', attSet.attributes)
      commit('REDRAW_LIST_OF_ATTRIBUTES')
    },

    clearEditAttributeSet: ({ commit }) => {
      commit('CLEAR_ATTRIBUTE_SET_TO_EDIT')
    },

    editAttribute: ({ commit }, att) => {
      commit('EDIT_ATTRIBUTE_ON_LIST', att)
      commit('CLEAR_EDIT_ATTRIBUTE_ID_TO_EDIT')
      commit('REDRAW_LIST_OF_ATTRIBUTES')
    },

    clearEditAttribute: ({ commit }) => {
      commit('CLEAR_EDIT_ATTRIBUTE_ID_TO_EDIT')
    },

    clearAttributeList: ({ commit }) => {
      commit('CLEAR_ATTRIBUTE_LIST')
    },

    saveAttributeSet: ({ commit }, attributeSet) => {
      attributeSet.attributes.forEach((element, index) => {
        // salva os atributos com as suas ordens de acordo com a listagem draggable
        element.order = index + 1
      })

      return axios.post('/attributesSet/typeConfig', { attributeSet })
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error))
    },

    getAttributeSetById: ({ commit }, attSetId) => {
      return axios.get(`/attributesSet/typeConfig?attSetId=${attSetId}`)
        .then(response => {
          if (response.data === 'GENERAL') {
            Promise.reject(response.data)
          }
          return response.data
        })
        .catch(error => error.message)
    },

    addAttribute: ({ commit }, att) => {
      commit('ADD_ATTRIBUTE_TO_LIST', att)
      commit('REDRAW_LIST_OF_ATTRIBUTES')
    },

    removeAttribute: ({ commit }, attOrder) => {
      commit('REMOVE_ATTRIBUTE_FROM_LIST', attOrder)
      commit('REDRAW_LIST_OF_ATTRIBUTES')
    },

    loadAttributeTypes: ({ commit }) => {
      return axios.get('/attributesSet/types')
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.data))
    },

    removeAttributeSet: ({ commit }, idAtributoCfg) => {
      return new Promise((resolve, reject) => {
        axios.delete('/attributesSet/removeAttributeSet', {params: { idAtributoCfg: idAtributoCfg }}).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
    attributeToEditOrder: state => state.attributeToEditOrder,
    attributesList: state => state.attributesList,
    editingAttribute: state => state.attributeToEditOrder ? state.attributesList[state.attributeToEditOrder] : state.attributesList,
    attributeSetToEdit: state => state.attributeSetToEdit,
    attributesListIsDrawed: state => state.attributesListIsDrawed,
    attributesSetList: state => state.attributesSetList
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/attributesSet.js